import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/locals.actions';
import * as home from '../../../../actions/process.home.actions';

import Hidden from '@material-ui/core/Hidden';

import Menu from '../Menu';
import Table from './Table';
import FilterMenu from './FilterMenu';

import Snackbar from '../../../labels/Snackbar';
import Loading from '../../../dialogs/loading';
import Error from '../../../dialogs/Error';
import { FilterIcon } from '../../../../images/icons/WrapSvg';

// eslint-disable-next-line
import style from './_style.css';

function toolbar(handleFilter, secondary = false) {
    const color = secondary ? 'secondary' : 'primary';
    return <FilterIcon key={'filter-menu-toolbar'} color={color} onClick={handleFilter} />;
}

class Locals extends React.Component {
    state = {
        hide: false,
        open: undefined,
        error: '',
        filtro: undefined,
        window_searchs: this.props.window_searchs,
    };

    constructor(props) {
        super(props);
        props.all();
    }

    componentDidMount() {
        const tools = [toolbar(this.handleFilter)];
        this.props.setTools(tools);
        this.props.setSearch(true);
    }

    componentWillUnmount() {
        this.props.setTools([]);
        this.props.setSearch(false);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.displays_has_error) {
            this.setState({
                hide: false,
                open: undefined,
            });
            nextProps.props.all();
        }
    }

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    };

    handleBack = () => {
        /*
            let path = this.props.history.location.pathname.split('/');
            path.splice(path.length - 1, 1);
            path = path.join('/');
            this.props.history.push(path);
            */
           if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    };

    handleFilter = (event) => {
        this.setState({ open: event.currentTarget });
    };

    handleCloseMenu = (filtro) => {
        const tools = [toolbar(this.handleFilter, filtro)];
        this.props.setTools(tools);
        this.setState({ open: undefined, filtro: filtro });
    };

    handleError = (message) => {
        this.setState({ error: message });
    };

    handleClose = () => {
        this.setState({ error: '' });
    };

    render() {
        const { info, locals_is_loading, locals_has_errored } = this.props;
        const { error, filtro, open } = this.state;
        if (
            info &&
            info.security &&
            info.security.totalPermits &&
            !(info.security.totalPermits.some((f) => f === '20' || f === '59' || f === '68')  &&
              info.security.licencias.some((f) => f.id === 154 && f.activo))
        ) {
            return <Error open id={'unauthorized_access'} handleClose={this.handleBack} />;
        } else if (locals_has_errored.hasErrored) {
            return <Error open type={locals_has_errored.hasErrored}  message={locals_has_errored.error} handleClose={this.handleBack} />;
        } else {
            return (
                <div className={'flex_full_row bg_ice_blue'}>
                    <Hidden xsDown>
                        <div
                            className={
                                'flex_20 overflow_y_scroll padding_top_12 shadow_right_on_tablet bg_white'
                            }
                            onScroll={this.handleScroll}
                        >
                            <Menu code={2} />
                        </div>
                    </Hidden>
                    {locals_is_loading && <Loading open opacity />}
                    <div className={'flex_80 center'}>
                        <div
                            className={'flex_full overflow_y_scroll height100 bg_ice_blue showbar'}
                        >
                            <Table {...this.props} filtro={filtro} />
                        </div>
                    </div>
                    {open && (
                        <FilterMenu
                            anchorEl={open}
                            filtro={filtro}
                            handleClose={this.handleCloseMenu.bind(this)}
                        />
                    )}
                    {error && (
                        <Snackbar
                            open={true}
                            variant="error"
                            text={error}
                            onClose={this.handleClose}
                        />
                    )}
                </div>
            );
        }
    }
}

Locals.propTypes = {
    window_searchs: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => {
    return {
        window_searchs: state.window_searchs,
        locals: state.locals,
        locals_is_loading: state.locals_is_loading,
        locals_has_errored: state.locals_has_errored,
        info: state.info,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions, home), dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(Locals));



// WEBPACK FOOTER //
// ./src/components/complex/inventory/locals/Index.js